document.addEventListener("DOMContentLoaded", function () {
  const menus = document.querySelectorAll(".custom-footer__menu");

  menus.forEach((menu) => {
    const title = menu.querySelector(".custom-footer__menu-title");
    const plusIcon = menu.querySelector(".icon-plus");
    const minusIcon = menu.querySelector(".icon-minus");

    title.addEventListener("click", () => {
      if (window.innerWidth < 900) {
        const isOpen = menu.classList.contains("open");

        menus.forEach((m) => {
          m.classList.remove("open");
          m.querySelector(".icon-plus").classList.add("active");
          m.querySelector(".icon-minus").classList.remove("active");
        });

        if (!isOpen) {
          menu.classList.add("open");
          plusIcon.classList.remove("active");
          minusIcon.classList.add("active");
        }
      }
    });
  });
});
